import React from "react";

import { Container } from "./styles";

export default function ModalPopup({ message, visible = false, onClick }) {
	const cunstomOnClick = (event) => {
		if (onClick) {
			onClick(event);
		}
	};

	return (
		<Container style={{ display: `${visible ? "block" : "none"}` }}>
			<div className='modal fade'>
				<div className='modal-dialog'>
					<div className='modal-content'>
						<div className='modal-header'>
							<button
								type='button'
								className='close'
								onClick={cunstomOnClick}>
								<span aria-hidden='true'>&times;</span>
							</button>
						</div>
						<img
							loading="lazy"
							className="img-responsive"
							src={
								require("@/assets/img/popup-communication-image.png").default
							}
							alt="cão e gato"
						/>
						<div className='modal-body'>
							<span style={{ fontWeight: 800, color: "#e94e4e" }}>IMPORTANTE: Alterações no Programa Fidelidade Gerioox!</span> <br /><br />
							De acordo com nosso compromisso de transparência com nossos clientes,
							Informamos que nosso o Programa Fidelidade encontra-se temporariamente fora do ar, para correções de instabilidade.
							Estamos buscando intensamente solucionar este problema, o mais rápido possível. <br /><br />
							<span style={{ textAlign: "right" }}>Seguimos à disposição através do canal oficial de contato: contato.br@labyes.com. </span>
						</div>
					</div>
				</div>
			</div>
		</Container>
	);
}
